import { ChangeDetectionStrategy, Component, inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EpErrorService, ToastService } from '@isophi/core-ui';
import { KindergartenService, Organization, OrganizationService } from '@isophi/mng-api';
import { TranslocoService } from '@jsverse/transloco';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize, Subscription } from 'rxjs';

@Component({
  selector: 'app-organisation-form',
  templateUrl: './organisation-form.component.html',
  styleUrls: ['./organisation-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OrganisationFormComponent implements OnDestroy {
  private readonly epErrorService = inject(EpErrorService);
  basicForm: FormGroup;

  private _subs: Subscription[] = [];

  private organisation: Organization | null = null;

  constructor(
    private formBuilder: FormBuilder,
    private kindergartenService: KindergartenService,
    private organisationService: OrganizationService,
    private spinner: NgxSpinnerService,
    private translocoService: TranslocoService,
    private toastr: ToastService
  ) {
    this.basicForm = this.formBuilder.group({
      officialName: [''],
      redIzo: [''],
      lawId: [''],
      databox: [''],
      website: [''],
    });

    this._subs.push(
      this.organisationService.organizationMyOrganizationRetrieve().subscribe({
        next: (val) => {
          this.organisation = val;
          this.basicForm.patchValue(val);
        },
      })
    );
  }

  onSubmit(): void {
    if (this.basicForm.valid) {
      this.spinner.show();

      this.organisationService
        .organizationPartialUpdate(this.organisation.id, this.basicForm.value)
        .pipe(finalize(() => this.spinner.hide()))
        .subscribe({
          next: () => {
            this.toastr.success(
              this.translocoService.translate('settings/basicDataSuccess'),
              this.translocoService.translate('settings/basicData')
            );
          },
          error: (e) => {
            this.epErrorService.handleEpErrorResponse(e, this.translocoService.translate('settings/basicDataError'));
            this.spinner.hide();
          },
        });
    }
  }

  ngOnDestroy(): void {
    this._subs.forEach((_sub) => _sub.unsubscribe());
  }
}
